/**
 * Generic filter drawer wrapper. Renders RpaDrawer with a footer containing
 * Apply and Clear All buttons wired to the form via formId.
 */
import { Button } from "@blurb/codex-react";
import { ReactNode } from "react";
import { RpaDrawer } from "../../rpi-core/drawer/RpaDrawer";
import { useFilterStyles } from "./filterStyles";

type FilterDrawerProps = {
  formId: string;
  isOpened: boolean;
  onClose: () => void;
  children: ReactNode;
};

export function FilterDrawer({ formId, isOpened, onClose, children }: FilterDrawerProps) {
  const { classes } = useFilterStyles();

  return (
    <RpaDrawer title="Filters" opened={isOpened} onClose={onClose}>
      {children}
      <RpaDrawer.Footer>
        <div className={classes.footer}>
          <Button variant="filled" fullWidth intent="primary" type="submit" form={formId}>
            Apply
          </Button>
          <Button variant="text" intent="primary" type="reset" form={formId}>
            Clear All
          </Button>
        </div>
      </RpaDrawer.Footer>
    </RpaDrawer>
  );
}
